<script>
import * as d3 from 'd3'

import AreaChart from '@/components/plots/AreaChart'

export default {
  computed: {
    curve_type() { return d3.curveNatural }
  },
  extends: AreaChart,
  name: 'candela-area-chart-spline'
}
</script>
